// import { Settings } from './services/auth.service';
import { CrashService } from './services/crash.service';
import { IonicStorageModule } from '@ionic/storage';
import { Media } from '@ionic-native/media/ngx';
import { MediaCapture } from '@ionic-native/media-capture/ngx';
import { FirebaseX } from '@ionic-native/firebase-x/ngx';
import { SharedModule } from './shared/shared.module';
import { ConfigService } from './services/config.service';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { TeamsService } from './services/teams.service';
import { WindowService } from './services/window.service';
import { IapService } from './services/iap.service';
import { AuthGuard, AuthService } from './services/auth.service';
import { FirebaseService } from './services/firebase.service';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import ContactsX from 'cordova-plugin-contacts-x';
import { Camera } from '@ionic-native/camera/ngx';
import { InAppPurchase2 } from '@ionic-native/in-app-purchase-2/ngx';

import { AngularFireModule } from '@angular/fire';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { firebaseConfig } from './app.config';
import { VideoEditor } from '@ionic-native/video-editor/ngx';

import {
  TranslateModule,
  TranslateLoader,
  TranslatePipe,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { GSDIntlTelInputModal } from './components/gsd-intl-tel-input/gsd-intl-tel-input-modal';
import { IAPModal } from './components/iap-modal/iap-modal';
import { IAPBrowserModal } from './components/iap-browser-modal/iap-browser-modal';
import { MediaModal } from './components/media-modal/media-modal';
import { JwtModule } from '@auth0/angular-jwt';
import { RenameModal } from './components/rename-modal/rename-modal';
import { TutorialModal } from './components/tutorial-modal/tutorial-modal';
import { MediaService } from './services/media.service';
import { File } from '@ionic-native/file/ngx';

// >>> LATEST MEDIA FEATURES
import { ImagePicker } from '@ionic-native/image-picker/ngx';
import { StreamingMedia } from '@ionic-native/streaming-media/ngx';
import { PhotoViewer } from '@ionic-native/photo-viewer/ngx';
import { HTTP } from '@ionic-native/http/ngx';
import { PushService } from './services/push.service';
// <<< LATEST MEDIA FEATURES

import { environment } from '../environments/environment';
import { USE_EMULATOR as USE_AUTH_EMULATOR } from '@angular/fire/auth';
import { USE_EMULATOR as USE_DATABASE_EMULATOR } from '@angular/fire/database';
import {
  SETTINGS,
  USE_EMULATOR as USE_FIRESTORE_EMULATOR,
} from '@angular/fire/firestore';
import { USE_EMULATOR as USE_FUNCTIONS_EMULATOR } from '@angular/fire/functions';

/*
<!-- The core Firebase JS SDK is always required and must be listed first -->
<script src="/__/firebase/7.14.5/firebase-app.js"></script>

<!-- TODO: Add SDKs for Firebase products that you want to use
     https://firebase.google.com/docs/web/setup#available-libraries -->
<script src="/__/firebase/7.14.5/firebase-analytics.js"></script>

<!-- Initialize Firebase -->
<script src="/__/firebase/init.js"></script>
*/

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    GSDIntlTelInputModal,
    IAPModal,
    IAPBrowserModal,
    MediaModal,
    RenameModal,
    TutorialModal,
  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AngularFireModule.initializeApp(firebaseConfig),
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem('access_token');
        },
        allowedDomains: ['localhost'],
        disallowedRoutes: ['localhost/auth/phone'],
      },
    }),
    IonicStorageModule.forRoot(),
    AngularFireStorageModule,
  ],
  providers: [
    TeamsService,
    WindowService,
    IapService,
    {
      provide: ErrorHandler,
      useClass: CrashService,
    },
    PushService,
    AuthService,
    FirebaseService,
    FirebaseX,
    Camera,
    File,
    HTTP,
    StatusBar,
    InAppPurchase2,
    AuthGuard,
    ConfigService,
    MediaService,
    Storage,
    ContactsX,
    MediaCapture,
    ImagePicker,
    StreamingMedia,
    PhotoViewer,
    VideoEditor,
    Media,
    File,
    // SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: USE_AUTH_EMULATOR,
      useValue: environment.useEmulators ? ['localhost', 9099] : undefined,
    },
    {
      provide: SETTINGS,
      useValue: { experimentalForceLongPolling: true },
    },
    {
      provide: USE_DATABASE_EMULATOR,
      useValue: environment.useEmulators ? ['localhost', 9000] : undefined,
    },
    {
      provide: USE_FIRESTORE_EMULATOR,
      useValue: environment.useEmulators ? ['localhost', 8080] : undefined,
    },
    {
      provide: USE_FUNCTIONS_EMULATOR,
      useValue: environment.useEmulators ? ['localhost', 5001] : undefined,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  // Put experimentalForceLongPolling back in, have to remember how
  // https://github.com/cypress-io/cypress/issues/2374
  constructor() {}
}
